<template>
  <div id="block-level">
    <Take5DailyLayout :isListPage="true">
      <MediaGrid 
        v-if="!pending && data"
        class="lg:col-span-3"
        :primary="primary"
        :secondary="secondary"
        :tertiary="tertiary"
        :currentPage="currentPage"
        :limit="limit"
        :showSearch="true"
        :currentSearch="searchQuery"
        :hasNext="hasNext"
        :hasPrev="hasPrev"
        :totalPages="totalPages"
        :showPageNumbers="showPageNumbers"
        titlePosition="bottom"
      />

      <div v-else-if="pending" class="border-r-0 md:border-r md:border-gray-300 lg:col-span-3 
               flex items-center justify-center py-20">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>

      <MediaGrid 
        v-else
        class="lg:col-span-3"
        :primary="primary"
        :secondary="secondary"
        :tertiary="tertiary"
        :currentPage="currentPage"
        :limit="limit"
        :showSearch="true"
        :currentSearch="searchQuery"
        :hasNext="hasNext"
        :hasPrev="hasPrev"
        :totalPages="totalPages"
        :showPageNumbers="showPageNumbers"
        titlePosition="bottom"
      />

    </Take5DailyLayout>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Take5DailyLayout from '~/layouts/take5daily.vue';
import MediaGrid from '~/components/ui/organism/take-five-daily/mediaGrid.vue';
import { useScrollToTop } from '~/composables/useScrollToTop';
import { PAGE_META } from '~~/shared/utils/pageMeta';
import { useTakeFiveDaily } from '~/composables/useTakeFiveDaily';

definePageMeta({
  layout: 'take-5-daily' as any
})

useHead(PAGE_META.TAKE_FIVE_DAILY)

const { 
  data, 
  error, 
  pending, 
  primary, 
  secondary, 
  tertiary,
  currentPage,
  searchQuery,
  limit,
  hasNext,
  hasPrev,
  totalPages
} = useTakeFiveDaily();

const showPageNumbers = computed(() => {
  const term = (searchQuery.value || '').trim();
  return term.length === 0; // true when no search; false when searching
});

useScrollToTop(currentPage, searchQuery);
</script>
